
import {of as observableOf,  Observable, BehaviorSubject } from 'rxjs';

import {share, map, tap} from 'rxjs/operators';
import { BaseEntity } from '../base/BaseEntity';
import { CrudOperations } from '../interfaces/crudOperations';
import { HttpClient, HttpParams } from '@angular/common/http';
import { IQueryResult } from '../base/interfaces/IQueryResult';
import { IDocumentResult } from '../base/interfaces/IDocumentResult';
import { QueryParams } from '../types/query-parameters';
import { IPostbackRequest } from '../base/interfaces/ipostback-request';
import { IPostbackResult } from '../base/interfaces/ipostback-result';

export class BaseService<T extends BaseEntity> implements CrudOperations<T> {
    /**
     *
     */
    data: T[] = null;
    localCache: BehaviorSubject<Array<T>> = new BehaviorSubject([]);

     constructor(
        protected http: HttpClient,
        protected rootUrl: string,
        protected endpoint: string
    ) {
    }
  Postback(code: string, model: IPostbackRequest<T>): Observable<IPostbackResult<T>> {
    const params = {};
    params['taskCode'] = code;    
    return this.http.post<IPostbackResult<T>>(`${this.rootUrl}/${this.endpoint}/postback`, model, {params: params});
  }
    SetEndpoint(endpoint: string) {
      this.endpoint = endpoint;
    }
    New(params?: QueryParams): Observable<IDocumentResult<T>> {
      const par = {};
      if (params) {
        for (let key in params) {
          const value = params[key];
          par[key] = value;
        }
      }
      return this.http.post<IDocumentResult<T>>(`${this.rootUrl}/${this.endpoint}/create`, null, {params: par});
    }
    Create(model: T): Observable<any> {
        if (!model.id) {
          model.id = BaseEntity.GetEmptyGuid();
        }
        return this.http.post<T>(`${this.rootUrl}/${this.endpoint}`, model).pipe(tap({
          next: val => {
            this.ClearCache();
          }
        }));
    }
    Update(model: T): Observable<any> {
      return this.http.put<T>(`${this.rootUrl}/${this.endpoint}`, model).pipe(tap({
        next: val => {
          this.ClearCache();
        }
      }));
    }
    Delete(id: string): Observable<any> {
      return this.http.delete(`${this.rootUrl}/${this.endpoint}/${id}`).pipe(tap({
        next: val => {
          this.ClearCache();
        }
      }));
    }
    Get(id: string): Observable<IDocumentResult<T>> {
        return this.http.get<IDocumentResult<T>>(`${this.rootUrl}/${this.endpoint}/${id}`);
    }
    GetAll(sort: string = null, sortOrder: string = null, page: number = 0, pageSize: number = 0, queryparams:object = null): Observable<IQueryResult<T>> {
      const params = {};
      params['$top'] = pageSize || 50;
      if (page) {
        params['$skip'] = (page - 1) * params['$top'];
      }
      if (sort) {
        params['$orderby'] = sort.toString();
        if (sortOrder) {
          params['$orderby'] += ` ${sortOrder}`;
        }
      }
      if(queryparams){
        for (let key in queryparams){
          const val = queryparams[key];
          params[key] = val;
        }
      }


        return this.http.get<IQueryResult<T>>(`${this.rootUrl}/${this.endpoint}`, {params: params});
    }
    Filter(filter: any, sort: string = null, sortOrder: string= null, page?: number, pageSize?: number): Observable<IQueryResult<T>> {
      const params = {};
      if (filter) {
        if (typeof filter === 'object') {
          for (const key in filter) {
            if (filter.hasOwnProperty(key)) {
              const value = filter[key];
              if(value){
                params[key] = value;
              }              
            }
          }
        }
        if (typeof filter === 'string' || filter instanceof String) {
          params['$filter'] = filter;
        }
      }
      if (!pageSize) {
        pageSize = 50;
      }
      params['$top'] = pageSize;
      if (page) {
        if (page > 1) {
          params['$skip'] = pageSize * (page - 1);
        }
        params['page'] = page;
      }
      if (sort) {
        params['sort'] = sort.toString();
      }
      if (sortOrder) {
        params['sortOrder'] = sortOrder.toString();
      }
      if (sort) {
        params['$orderby'] = sort.toString();
        if (sortOrder) {
          params['$orderby'] += ` ${sortOrder}`;
        }
      }      

      return this.http.get<IQueryResult<T>>(`${this.rootUrl}/${this.endpoint}`, {params: params});
  }
    Search(query: string): Observable<IQueryResult<T>> {
      let params = new HttpParams();
      if (query) {
        params = params.append('querystring', query);
      }
      return this.http.get<IQueryResult<T>>(`${this.rootUrl}/${this.endpoint}`, {params: params});
    }
    ClearCache() {
      this.data = null;
    }
    GetCached(recycle: boolean = false): Observable<T[]> {
        if (recycle) {
          this.ClearCache();
        }
        if (this.data) {
          this.localCache.next(this.data);
        } else {
          this.http.get<IQueryResult<T>>(`${this.rootUrl}/${this.endpoint}`).subscribe(res => {
            if (res) {
              this.data = res.payload;
              this.localCache.next(this.data);
            }
          });
        }
        return this.localCache.asObservable();
      }
}
